/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 다이얼로그 토글태그 컴포넌트
 * 버전 : 1.0
 * 파일명 : DialogEdu_Level.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================ 

 *================================================================
 */

import styled from 'styled-components'
import { NextButton, NextButtonWrapper } from '../common/CommonStyled'
import { useDialogStore } from 'src/stores/DialogStore'
import ToggleTag from '../common/ToggleTag'
import { LoadMapDataFilter } from './LoadMapData'

const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 80px;
    
    padding: 20px 24px;
`

const DialogEdu_Level = () => {
    const syncField = useDialogStore((state)=>state.syncField)
    const resetField = useDialogStore((state)=>state.resetField)
    const setField = useDialogStore((state)=>state.setField)
    const handleSubmit = async () => {
        await syncField('edu_level','base','temp')
        await syncField('highschool_type','base','temp')
        LoadMapDataFilter()
        setField('isOpen',false)
    }
    const onClickReset = ()=>{
        resetField('temp_edu_level')
        resetField('temp_highschool_type')
    }
  return (
    <PageWrapper>
        <ToggleTag/>
        <NextButtonWrapper $isBorder={false}>
            <NextButton style={{background:'#F5F5F5', color:'#7F7F89', minWidth:'90px', width:'90px', boxShadow:'none', border:'1px solid #00001480'}} onClick={onClickReset}>초기화</NextButton>
            <NextButton onClick={handleSubmit} style={{margin:'5px',padding:'10px', height:'46px', boxShadow:'none'}}>적용</NextButton>
        </NextButtonWrapper>
    </PageWrapper>
)
}

export default DialogEdu_Level